// import { configureStore } from '@reduxjs/toolkit';
// import authReducer from './authSlice';

// const store = configureStore({
//   reducer: {
//     auth: authReducer,
//   },
// });

// export default store;

import { configureStore } from "@reduxjs/toolkit";
import createSagaMiddleware from 'redux-saga';
import { loadState, saveState } from "./config/sessionPersist";
import reducers from "./reducers";
// slices

// import listings from "../features/listings/listingsSlice"; // add when you have it
import rootSaga from "./rootSaga";

const sagaMiddleware = createSagaMiddleware();

const preloadedState = loadState();

export const store = configureStore({
  reducer: reducers,
  preloadedState,
  middleware: (gdm) => gdm({ serializableCheck: false }).concat(sagaMiddleware),
});

sagaMiddleware.run(rootSaga);

// persist according to PERSIST map
store.subscribe(() => {
  saveState(store.getState());
});
